import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { GetAPI, PostAPI, PutAPI } from '../ultilies/API';
import '../css/brandForm.css';

function BrandForm() {
    const { state } = useLocation(); // Contains brand data if editing
    const navigate = useNavigate();
    const isEdit = !!state;

    const [formData, setFormData] = useState({
        name: state?.name || '',
        industryId: state?.industryId || '',
        description: state?.description || '',
        playableDescription: state?.playableDescription || '',
        brandLogo: state?.brandLogo || null,
        playableBanner: state?.playableBanner || null
    });

    const [industries, setIndustries] = useState([]);
    const [previews, setPreviews] = useState({
        logo: state?.brandLogo || null,
        banner: state?.playableBanner || null
    });

    useEffect(() => {
        // Fetch industries for the dropdown
        GetAPI('/cms/industries', (res) => {
            if (res?.success) setIndustries(res.data);
        });
    }, []);

    const handleFileChange = (e, field) => {
        const file = e.target.files[0];
        if (file && file.name.endsWith('.webp')) {
            setPreviews({ ...previews, [field]: URL.createObjectURL(file) });
            setFormData({ ...formData, [field === 'logo' ? 'brandLogo' : 'playableBanner']: file });
        } else {
            alert("Please upload only .webp files");
            e.target.value = null;
        }
    };

    const removeFile = (field) => {
        setPreviews({ ...previews, [field]: null });
        setFormData({ ...formData, [field === 'logo' ? 'brandLogo' : 'playableBanner']: null });
    };

    const handleSubmit = () => {
        const apiCall = isEdit ? PutAPI : PostAPI;
        const url = isEdit ? `/cms/brands/${state._id}` : `/cms/brands`;

        apiCall(url, formData, (res) => {
            if (res?.success) navigate('/brand');
        });
    };

    return (
        <div className="brand-form-container">
            <div className="preview-sidebar">
                <div className="mobile-mockup">
                    <div className="screen">
                        {previews.banner ? (
                            <img src={previews.banner} alt="Banner" className="banner-preview" />
                        ) : (
                            <div className="placeholder-banner">Banner Preview</div>
                        )}
                        <div className="logo-overlay">
                            {previews.logo ? (
                                <img src={previews.logo} alt="Logo" className="logo-preview" />
                            ) : (
                                <div className="placeholder-logo">Logo</div>
                            )}
                        </div>
                        <div className="content-preview">
                            <h4>{formData.name || "Brand Name"}</h4>
                            <p>{formData.playableDescription || "Playable description will appear here..."}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="form-main">
                <h2>{isEdit ? 'Edit Brand' : 'Create Brand'}</h2>
                
                <label>Industry</label>
                <select value={formData.industryId} onChange={e => setFormData({...formData, industryId: e.target.value})}>
                    <option value="">Select Industry</option>
                    {industries.map(ind => <option key={ind._id} value={ind._id}>{ind.name}</option>)}
                </select>

                <label>Brand Name</label>
                <input type="text" value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} placeholder="e.g. CocaCola" />

                <label>Description</label>
                <textarea value={formData.description} onChange={e => setFormData({...formData, description: e.target.value})} placeholder="Brand general description" />

                <div className="file-upload-row">
                    <div className="upload-box">
                        <label>Brand Logo (.webp)</label>
                        {!previews.logo ? (
                            <input type="file" accept=".webp" onChange={e => handleFileChange(e, 'logo')} />
                        ) : (
                            <div className="file-attached">
                                <span>Logo Attached</span>
                                <button onClick={() => removeFile('logo')}>Remove</button>
                            </div>
                        )}
                    </div>

                    <div className="upload-box">
                        <label>Playable Banner (.webp)</label>
                        {!previews.banner ? (
                            <input type="file" accept=".webp" onChange={e => handleFileChange(e, 'banner')} />
                        ) : (
                            <div className="file-attached">
                                <span>Banner Attached</span>
                                <button onClick={() => removeFile('banner')}>Remove</button>
                            </div>
                        )}
                    </div>
                </div>

                <label>Playable Description</label>
                <input type="text" value={formData.playableDescription} onChange={e => setFormData({...formData, playableDescription: e.target.value})} placeholder="Short description for playable" />

                <div className="form-actions">
                    <button className="cancel-btn" onClick={() => navigate('/brand')}>Cancel</button>
                    <button className="save-btn" onClick={handleSubmit}>Save Brand</button>
                </div>
            </div>
        </div>
    );
}

export default BrandForm;